// extracted by mini-css-extract-plugin
export default {"BannerTable":"BannerTable_BannerTable__ULlE4","EditBanner":"BannerTable_EditBanner__gitwy","DeleteButton":"BannerTable_DeleteButton__vbume"};